import { render, staticRenderFns } from "./ProposalItemSpec.vue?vue&type=template&id=58c55a90&"
import script from "./ProposalItemSpec.vue?vue&type=script&lang=js&"
export * from "./ProposalItemSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports